import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { FormScriptResponse } from '~/models/Commons ';
import { RootState } from '~/store/index';

interface State {
    contracts: FormScriptResponse[];
     authenticated: boolean;
}

const initialState: State = {
    contracts: [],
    authenticated:false
};

const ContractSlice = createSlice({
    name: 'contracts',
    initialState,
    reducers: {
        SET_CONTRACTS(state, { payload }: PayloadAction<FormScriptResponse[]>) {
            state.contracts = payload;
        },
            DELETE_CONTRACT_BYID(state, { payload }: PayloadAction<number>) {
            if (!Array.isArray(state.contracts)) {
                state.contracts = []; 
            }

            state.contracts = state.contracts.map(item =>
                item.id !== payload ? item : { ...item, active: false }
            );
        },

        ADD_CONTRACT(state, { payload }: PayloadAction<FormScriptResponse>) {
            const newScripts = [...state.contracts, payload];
            state.contracts = newScripts;
        },
        PATCH_CONTRACT(state, { payload }: PayloadAction<FormScriptResponse>) {
            const newScripts = [...state.contracts];
            const findInd = newScripts.findIndex(({ id }) => id === payload.id);
            if (findInd < 0) return;

            newScripts[findInd] = { ...payload };
            state.contracts = newScripts;
        },
         SET_AUTHENTICATED(state, { payload }: PayloadAction<boolean>) {
            state.authenticated = payload;
        },
    },
});

export const selectContracts = (state: RootState) => state.contracts;

export const { SET_CONTRACTS, DELETE_CONTRACT_BYID, ADD_CONTRACT, PATCH_CONTRACT,SET_AUTHENTICATED } =
    ContractSlice.actions;

export default ContractSlice.reducer;
